<script>
import { required, between } from "vuelidate/lib/validators";

import { authFackMethods, notificationMethods } from "@/state/helpers";
// eslint-disable-next-line no-unused-vars

/**
 * Register component
 */
export default {
  data() {
    return {
      username: "",
      info: false,
      phone: "",
      type: false,
      submitted: false,
    };
  },
  validations: {
    username: { required },
    phone: { required, between: between(500000000, 599999999) },
  },

  created() {
   

    // socket.on("connect_error", (err) => {
    //   if (err.message === "invalid username") {
    //     this.usernameAlreadySelected = false;
    //   }
    // });
  },
  mounted() {
   if(this.$route.query.name && this.$route.query.phone ) {
    this.username = this.$route.query.name
    this.phone = this.$route.query.phone
    this.info = this.$route.query.info
    this.tryToLogIn();
   }
    // setInterval(() => {
    //  document.title = "ახალი შეტყობინება";
    // }, 2000);

    // setInterval(() => {
    //  document.title = "ImediL Chat";
    // }, 4000);
    if (localStorage.getItem("reloaded")) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem("reloaded");
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem("reloaded", "1");

      location.reload();
    }
  },
  computed: {
    
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    notificationAutoCloseDuration() {
      return this.$store && this.$store.state.notification ? 5 : 0;
    },
  },
  methods: {
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          this.startLogin = true;
          const { email = "asd", password = "asdasd" , info = false } = this;
          if (email && password) {
            const currentDate = new Date();
            const time = currentDate.getTime();
            localStorage.setItem("startTime", time);
            localStorage.setItem("username", this.username);
            localStorage.setItem("phone", this.phone);
            localStorage.setItem("info", this.info);
            this.login({ email, password, info });
          }
        }
        // const { username, type, phone } = this;
        //  socket.auth = { username:"levani", type: false, phone:"44332433" };
        //  socket.connect();
        // this.$router.push({ name: 'chat' })
      }
    },
  },
};
</script>

<template>
  <div class="account-pages pt-2 pt-md-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-6">
          <div class="text-center mb-0 mb-md-4">
            <router-link to="/" class="auth-logo mb-4 mb-md-5 d-block">
              <img
                src="@/assets/images/logo.png"
                alt
                height="73"
                class="logo logo-dark"
              />
              <img
                src="@/assets/images/logo.png"
                alt
                height="73"
                class="logo logo-light"
              />
            </router-link>
          </div>
          <div class="card">
            <div class="card-head pt-3 pl-3">
              <div class="col-12 pl-md-3">
                <h4 class="imedil_h text-info">შეიყვანე მონაცემები</h4>
              </div>
            </div>
            <div class="card-body p-md-3">
              <b-alert
                :variant="notification.type"
                class="mt-3"
                v-if="notification.message"
                :show="notificationAutoCloseDuration"
                dismissible
                >{{ notification.message }}</b-alert
              >
              <div class="p-3">
                <form @submit.prevent="tryToLogIn">
                  <div class="form-group">
                    <label class="imedil_t">სახელი</label>
                    <div
                      class="
                        input-group
                        mb-3
                        bg-soft-light
                        input-group-lg
                        rounded-lg
                      "
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text border-light text-muted">
                          <i class="ri-user-line"></i>
                        </span>
                      </div>
                      <input
                        v-model="username"
                        type="text"
                        class="form-control bg-soft-light border-light"
                        :class="{
                          'is-invalid': submitted && $v.username.$error,
                        }"
                        placeholder="შეიყვანე სახელი"
                      />
                      <div
                        v-if="submitted && $v.username.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.username.required"
                          >სახელი აუცილებელია</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="form-group mt-4">
                    <label class="imedil_t">მობილური ტელეფონის ნომერი</label>
                    <div
                      class="
                        input-group
                        mb-3
                        bg-soft-light
                        input-group-lg
                        rounded-lg
                      "
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text border-light text-muted">
                          <i class="ri-phone-line"></i>
                        </span>
                      </div>
                      <input
                        v-model="phone"
                        type="text"
                        class="form-control bg-soft-light border-light"
                        placeholder="5XXXXXXXX"
                        :class="{ 'is-invalid': submitted && $v.phone.$error }"
                      />
                      <div
                        v-if="submitted && $v.phone.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.phone.required"
                          >ტელეფონის ნომერი აუცილებელია</span
                        >
                        <span v-if="!$v.phone.between"
                          >შეიყვანეთ სწორი ტელეფონის ნომერი მაგ: 5XXXXXXXX</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-12 col-md-6 m-auto">
                    <button class="btn btn-info btn-block" type="submit">
                      საუბრის დაწყება
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="mt-1 mt-md-3 text-center">
            <div class="alert alert-warning">
              *გაითვალისწინე, რომ ონლაინ კონსულტაციით შეძლებ მხოლოდ ზოგადი
              ინფორმაციის მიღებას.<br />
              *ონლაინ კონსულტაციით სარგებლობა შესაძლებელია 10:00-დან 19:00-მდე
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center BPGArial font-size-14 pt-3">
      <!-- {{new Date().getFullYear() }} -->
     <a href="https://communiq.io" style="color:gray" target="_blank"> Powered by <img src="@/assets/images/cq_logo.png" alt height="16" /></a>
    </p>
  </div>
</template>